enum LoadingEndState {
    // Loading screen disappeared when entities loaded
    Success,

    // Failed with timeout
    Timeout,

    // Failed with permanent error
    PermanentError,

    // User navigated away before the loading screen finished loading
    UserNavigatedAway,

    // Whether we showed the error screen due to donation request
    DonationRequested,
}

export default LoadingEndState;
